import { createFileRoute, Outlet, redirect, retainSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import StateMap from "@/components/Map/components/StateMap";
import Page from "@/components/Page";
import { mapSearchSchema } from "@/schemas/mapValidator";

const isOnKartRoot = (pathname: string) => /kart\/?$/.test(pathname);

function KartLayout() {
  return (
    <Page sx={{ scrollbarGutter: "auto" }}>
      <StateMap />
      <Outlet />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/kart")({
  validateSearch: zodValidator(mapSearchSchema),
  search: {
    middlewares: [retainSearchParams(true)], // Retain all search params when navigating to child routes
  },
  component: KartLayout,
  beforeLoad: (props) => {
    if (isOnKartRoot(props.location.pathname)) {
      throw redirect({
        to: "/kart/asset",
      });
    }
  },
});
